export const SUPPORTED_COUNTRIES = [
	{ countryCode: 'AF', name: 'Afghanistan', nativeName: 'افغانستان' },
	{ countryCode: 'AL', name: 'Albania', nativeName: 'Shqipëria' },
	{ countryCode: 'DZ', name: 'Algeria', nativeName: 'الجزائر' },
	{ countryCode: 'AS', name: 'American Samoa', nativeName: 'American Samoa' },
	{ countryCode: 'AO', name: 'Angola', nativeName: 'Angola' },
	{ countryCode: 'AI', name: 'Anguilla', nativeName: 'Anguilla' },
	{ countryCode: 'AG', name: 'Antigua and Barbuda', nativeName: 'Antigua and Barbuda' },
	{ countryCode: 'AR', name: 'Argentina', nativeName: 'Argentina' },
	{ countryCode: 'AM', name: 'Armenia', nativeName: 'Հայաստան' },
	{ countryCode: 'AW', name: 'Aruba', nativeName: 'Aruba' },
	{ countryCode: 'AU', name: 'Australia', nativeName: 'Australia' },
	{ countryCode: 'AT', name: 'Austria', nativeName: 'Österreich' },
	{ countryCode: 'AZ', name: 'Azerbaijan', nativeName: 'Azərbaycan' },
	{ countryCode: 'BH', name: 'Bahrain', nativeName: '‏البحرين' },
	{ countryCode: 'BD', name: 'Bangladesh', nativeName: 'বাংলাদেশ' },
	{ countryCode: 'BB', name: 'Barbados', nativeName: 'Barbados' },
	{ countryCode: 'BY', name: 'Belarus', nativeName: 'Белару́сь' },
	{ countryCode: 'BE', name: 'Belgium', nativeName: 'België' },
	{ countryCode: 'BZ', name: 'Belize', nativeName: 'Belize' },
	{ countryCode: 'BJ', name: 'Benin', nativeName: 'Bénin' },
	{ countryCode: 'BM', name: 'Bermuda', nativeName: 'Bermuda' },
	{ countryCode: 'BT', name: 'Bhutan', nativeName: 'ʼbrug-yul' },
	{ countryCode: 'BO', name: 'Bolivia', nativeName: 'Bolivia' },
	{ countryCode: 'BA', name: 'Bosnia and Herzegovina', nativeName: 'Bosna i Hercegovina' },
	{ countryCode: 'BW', name: 'Botswana', nativeName: 'Botswana' },
	{ countryCode: 'BR', name: 'Brazil', nativeName: 'Brasil' },
	{ countryCode: 'IO', name: 'British Indian Ocean Territory', nativeName: 'British Indian Ocean Territory' },
	{ countryCode: 'BN', name: 'Brunei', nativeName: 'Negara Brunei Darussalam' },
	{ countryCode: 'BG', name: 'Bulgaria', nativeName: 'България' },
	{ countryCode: 'BF', name: 'Burkina Faso', nativeName: 'Burkina Faso' },
	{ countryCode: 'BI', name: 'Burundi', nativeName: 'Burundi' },
	{ countryCode: 'KH', name: 'Cambodia', nativeName: 'Kâmpŭchéa' },
	{ countryCode: 'CM', name: 'Cameroon', nativeName: 'Cameroon' },
	{ countryCode: 'CA', name: 'Canada', nativeName: 'Canada' },
	{ countryCode: 'CV', name: 'Cape Verde', nativeName: 'Cabo Verde' },
	{ countryCode: 'KY', name: 'Cayman Islands', nativeName: 'Cayman Islands' },
	{ countryCode: 'CF', name: 'Central African Republic', nativeName: 'Ködörösêse tî Bêafrîka' },
	{ countryCode: 'TD', name: 'Chad', nativeName: 'Tchad' },
	{ countryCode: 'CL', name: 'Chile', nativeName: 'Chile' },
	{ countryCode: 'CN', name: 'China', nativeName: '中国' },
	{ countryCode: 'CX', name: 'Christmas Island', nativeName: 'Christmas Island' },
	{ countryCode: 'CC', name: 'Cocos (Keeling) Islands', nativeName: 'Cocos (Keeling) Islands' },
	{ countryCode: 'CO', name: 'Colombia', nativeName: 'Colombia' },
	{ countryCode: 'KM', name: 'Comoros', nativeName: 'Komori' },
	{ countryCode: 'CK', name: 'Cook Islands', nativeName: 'Cook Islands' },
	{ countryCode: 'CR', name: 'Costa Rica', nativeName: 'Costa Rica' },
	{ countryCode: 'HR', name: 'Croatia', nativeName: 'Hrvatska' },
	{ countryCode: 'CU', name: 'Cuba', nativeName: 'Cuba' },
	{ countryCode: 'CY', name: 'Cyprus', nativeName: 'Κύπρος' },
	{ countryCode: 'CZ', name: 'Czech Republic', nativeName: 'Česká republika' },
	{
		countryCode: 'CD',
		name: 'Democratic Republic of the Congo',
		nativeName: 'République démocratique du Congo',
	},
	{ countryCode: 'DK', name: 'Denmark', nativeName: 'Danmark' },
	{ countryCode: 'DJ', name: 'Djibouti', nativeName: 'Djibouti' },
	{ countryCode: 'DM', name: 'Dominica', nativeName: 'Dominica' },
	{ countryCode: 'DO', name: 'Dominican Republic', nativeName: 'República Dominicana' },
	{ countryCode: 'TL', name: 'East Timor', nativeName: 'Timor- Leste' },
	{ countryCode: 'EC', name: 'Ecuador', nativeName: 'Ecuador' },
	{ countryCode: 'EG', name: 'Egypt', nativeName: 'مصر‎' },
	{ countryCode: 'SV', name: 'El Salvador', nativeName: 'El Salvador' },
	{ countryCode: 'GQ', name: 'Equatorial Guinea', nativeName: 'Guinea Ecuatorial' },
	{ countryCode: 'ER', name: 'Eritrea', nativeName: 'ኤርትራ' },
	{ countryCode: 'EE', name: 'Estonia', nativeName: 'Eesti' },
	{ countryCode: 'ET', name: 'Ethiopia', nativeName: 'ኢትዮጵያ' },
	{ countryCode: 'FK', name: 'Falkland Islands', nativeName: 'Falkland Islands' },
	{ countryCode: 'FO', name: 'Faroe Islands', nativeName: 'Føroyar' },
	{ countryCode: 'FM', name: 'Federated States of Micronesia', nativeName: 'Micronesia' },
	{ countryCode: 'FJ', name: 'Fiji', nativeName: 'Fiji' },
	{ countryCode: 'FI', name: 'Finland', nativeName: 'Suomi' },
	{ countryCode: 'FR', name: 'France', nativeName: 'France' },
	{ countryCode: 'GF', name: 'French Guiana', nativeName: 'Guyane française' },
	{ countryCode: 'PF', name: 'French Polynesia', nativeName: 'Polynésie française' },
	{ countryCode: 'GA', name: 'Gabon', nativeName: 'Gabon' },
	{ countryCode: 'GE', name: 'Georgia', nativeName: 'საქართველო' },
	{ countryCode: 'DE', name: 'Germany', nativeName: 'Deutschland' },
	{ countryCode: 'GH', name: 'Ghana', nativeName: 'Ghana' },
	{ countryCode: 'GI', name: 'Gibraltar', nativeName: 'Gibraltar' },
	{ countryCode: 'GR', name: 'Greece', nativeName: 'Ελλάδα' },
	{ countryCode: 'GL', name: 'Greenland', nativeName: 'Kalaallit Nunaat' },
	{ countryCode: 'GD', name: 'Grenada', nativeName: 'Grenada' },
	{ countryCode: 'GP', name: 'Guadeloupe', nativeName: 'Guadeloupe' },
	{ countryCode: 'GU', name: 'Guam', nativeName: 'Guam' },
	{ countryCode: 'GT', name: 'Guatemala', nativeName: 'Guatemala' },
	{ countryCode: 'GG', name: 'Guernsey', nativeName: 'Guernsey' },
	{ countryCode: 'GN', name: 'Guinea', nativeName: 'Guinée' },
	{ countryCode: 'GW', name: 'Guinea- Bissau', nativeName: 'Guiné- Bissau' },
	{ countryCode: 'GY', name: 'Guyana', nativeName: 'Guyana' },
	{ countryCode: 'HT', name: 'Haiti', nativeName: 'Haïti' },
	{ countryCode: 'HN', name: 'Honduras', nativeName: 'Honduras' },
	{ countryCode: 'HK', name: 'Hong Kong', nativeName: '香港' },
	{ countryCode: 'HU', name: 'Hungary', nativeName: 'Magyarország' },
	{ countryCode: 'IS', name: 'Iceland', nativeName: 'Ísland' },
	{ countryCode: 'IN', name: 'India', nativeName: 'भारत' },
	{ countryCode: 'ID', name: 'Indonesia', nativeName: 'Indonesia' },
	{ countryCode: 'IR', name: 'Iran', nativeName: 'Irān' },
	{ countryCode: 'IQ', name: 'Iraq', nativeName: 'العراق' },
	{ countryCode: 'IE', name: 'Ireland', nativeName: 'Éire' },
	{ countryCode: 'IM', name: 'Isle of Man', nativeName: 'Isle of Man' },
	{ countryCode: 'IL', name: 'Israel', nativeName: 'יִשְׂרָאֵל' },
	{ countryCode: 'IT', name: 'Italy', nativeName: 'Italia' },
	{ countryCode: 'CI', name: 'Ivory Coast', nativeName: "Côte d'Ivoire" },
	{ countryCode: 'JM', name: 'Jamaica', nativeName: 'Jamaica' },
	{ countryCode: 'JP', name: 'Japan', nativeName: '日本' },
	{ countryCode: 'JE', name: 'Jersey', nativeName: 'Jersey' },
	{ countryCode: 'JO', name: 'Jordan', nativeName: 'الأردن' },
	{ countryCode: 'KZ', name: 'Kazakhstan', nativeName: 'Қазақстан' },
	{ countryCode: 'KE', name: 'Kenya', nativeName: 'Kenya' },
	{ countryCode: 'KI', name: 'Kiribati', nativeName: 'Kiribati' },
	{ countryCode: 'KW', name: 'Kuwait', nativeName: 'الكويت' },
	{ countryCode: 'KG', name: 'Kyrgyzstan', nativeName: 'Кыргызстан' },
	{ countryCode: 'LA', name: 'Laos', nativeName: 'ສປປລາວ' },
	{ countryCode: 'LV', name: 'Latvia', nativeName: 'Latvija' },
	{ countryCode: 'LB', name: 'Lebanon', nativeName: 'لبنان' },
	{ countryCode: 'LS', name: 'Lesotho', nativeName: 'Lesotho' },
	{ countryCode: 'LR', name: 'Liberia', nativeName: 'Liberia' },
	{ countryCode: 'LY', name: 'Libya', nativeName: '‏ليبيا' },
	{ countryCode: 'LI', name: 'Liechtenstein', nativeName: 'Liechtenstein' },
	{ countryCode: 'LT', name: 'Lithuania', nativeName: 'Lietuva' },
	{ countryCode: 'LU', name: 'Luxembourg', nativeName: 'Luxembourg' },
	{ countryCode: 'MO', name: 'Macau', nativeName: '澳門' },
	{ countryCode: 'MG', name: 'Madagascar', nativeName: 'Madagasikara' },
	{ countryCode: 'MW', name: 'Malawi', nativeName: 'Malawi' },
	{ countryCode: 'MY', name: 'Malaysia', nativeName: 'Malaysia' },
	{ countryCode: 'MV', name: 'Maldives', nativeName: 'Maldives' },
	{ countryCode: 'ML', name: 'Mali', nativeName: 'Mali' },
	{ countryCode: 'MT', name: 'Malta', nativeName: 'Malta' },
	{ countryCode: 'MH', name: 'Marshall Islands', nativeName: 'M̧ajeļ' },
	{ countryCode: 'MQ', name: 'Martinique', nativeName: 'Martinique' },
	{ countryCode: 'MR', name: 'Mauritania', nativeName: 'موريتانيا' },
	{ countryCode: 'MU', name: 'Mauritius', nativeName: 'Maurice' },
	{ countryCode: 'YT', name: 'Mayotte', nativeName: 'Mayotte' },
	{ countryCode: 'MX', name: 'Mexico', nativeName: 'México' },
	{ countryCode: 'MD', name: 'Moldova', nativeName: 'Moldova' },
	{ countryCode: 'MC', name: 'Monaco', nativeName: 'Monaco' },
	{ countryCode: 'MN', name: 'Mongolia', nativeName: 'Монгол улс' },
	{ countryCode: 'MS', name: 'Montserrat', nativeName: 'Montserrat' },
	{ countryCode: 'MA', name: 'Morocco', nativeName: 'المغرب' },
	{ countryCode: 'MZ', name: 'Mozambique', nativeName: 'Moçambique' },
	{ countryCode: 'NA', name: 'Namibia', nativeName: 'Namibia' },
	{ countryCode: 'NR', name: 'Nauru', nativeName: 'Nauru' },
	{ countryCode: 'NP', name: 'Nepal', nativeName: 'नेपाल' },
	{ countryCode: 'NL', name: 'Netherlands', nativeName: 'Nederland' },
	{ countryCode: 'NC', name: 'New Caledonia', nativeName: 'Nouvelle-Calédonie' },
	{ countryCode: 'NZ', name: 'New Zealand', nativeName: 'New Zealand' },
	{ countryCode: 'NI', name: 'Nicaragua', nativeName: 'Nicaragua' },
	{ countryCode: 'NE', name: 'Niger', nativeName: 'Niger' },
	{ countryCode: 'NG', name: 'Nigeria', nativeName: 'Nigeria' },
	{ countryCode: 'NU', name: 'Niue', nativeName: 'Niuē' },
	{ countryCode: 'NF', name: 'Norfolk Island', nativeName: 'Norfolk Island' },
	{ countryCode: 'KP', name: 'North Korea', nativeName: '북한' },
	{ countryCode: 'MP', name: 'Northern Mariana Islands', nativeName: 'Northern Mariana Islands' },
	{ countryCode: 'NO', name: 'Norway', nativeName: 'Norge' },
	{ countryCode: 'OM', name: 'Oman', nativeName: 'عمان' },
	{ countryCode: 'PK', name: 'Pakistan', nativeName: 'Pakistan' },
	{ countryCode: 'PW', name: 'Palau', nativeName: 'Palau' },
	{ countryCode: 'PA', name: 'Panama', nativeName: 'Panamá' },
	{ countryCode: 'PG', name: 'Papua New Guinea', nativeName: 'Papua Niugini' },
	{ countryCode: 'PY', name: 'Paraguay', nativeName: 'Paraguay' },
	{ countryCode: 'PE', name: 'Peru', nativeName: 'Perú' },
	{ countryCode: 'PH', name: 'Philippines', nativeName: 'Pilipinas' },
	{ countryCode: 'PL', name: 'Poland', nativeName: 'Polska' },
	{ countryCode: 'PT', name: 'Portugal', nativeName: 'Portugal' },
	{ countryCode: 'PR', name: 'Puerto Rico', nativeName: 'Puerto Rico' },
	{ countryCode: 'QA', name: 'Qatar', nativeName: 'قطر' },
	{ countryCode: 'MK', name: 'Republic of Macedonia', nativeName: 'Македонија' },
	{ countryCode: 'CG', name: 'Republic of the Congo', nativeName: 'République du Congo' },
	{ countryCode: 'RO', name: 'Romania', nativeName: 'România' },
	{ countryCode: 'RU', name: 'Russia', nativeName: 'Россия' },
	{ countryCode: 'RW', name: 'Rwanda', nativeName: 'Rwanda' },
	{ countryCode: 'RE', name: 'Réunion', nativeName: 'La Réunion' },
	{ countryCode: 'SH', name: 'Saint Helena', nativeName: 'Saint Helena' },
	{ countryCode: 'KN', name: 'Saint Kitts and Nevis', nativeName: 'Saint Kitts and Nevis' },
	{ countryCode: 'LC', name: 'Saint Lucia', nativeName: 'Saint Lucia' },
	{ countryCode: 'PM', name: 'Saint Pierre and Miquelon', nativeName: 'Saint- Pierre - et - Miquelon' },
	{
		countryCode: 'VC',
		name: 'Saint Vincent and the Grenadines',
		nativeName: 'Saint Vincent and the Grenadines',
	},
	{ countryCode: 'WS', name: 'Samoa', nativeName: 'Samoa' },
	{ countryCode: 'SM', name: 'San Marino', nativeName: 'San Marino' },
	{ countryCode: 'SA', name: 'Saudi Arabia', nativeName: 'العربية السعودية' },
	{ countryCode: 'SN', name: 'Senegal', nativeName: 'Sénégal' },
	{ countryCode: 'SC', name: 'Seychelles', nativeName: 'Seychelles' },
	{ countryCode: 'SL', name: 'Sierra Leone', nativeName: 'Sierra Leone' },
	{ countryCode: 'SG', name: 'Singapore', nativeName: 'Singapore' },
	{ countryCode: 'SK', name: 'Slovakia', nativeName: 'Slovensko' },
	{ countryCode: 'SI', name: 'Slovenia', nativeName: 'Slovenija' },
	{ countryCode: 'SB', name: 'Solomon Islands', nativeName: 'Solomon Islands' },
	{ countryCode: 'SO', name: 'Somalia', nativeName: 'Soomaaliya' },
	{ countryCode: 'ZA', name: 'South Africa', nativeName: 'South Africa' },
	{ countryCode: 'KR', name: 'South Korea', nativeName: '대한민국' },
	{ countryCode: 'SS', name: 'South Sudan', nativeName: 'South Sudan' },
	{ countryCode: 'ES', name: 'Spain', nativeName: 'España' },
	{ countryCode: 'LK', name: 'Sri Lanka', nativeName: 'śrī laṃkāva' },
	{ countryCode: 'SD', name: 'Sudan', nativeName: 'السودان' },
	{ countryCode: 'SR', name: 'Suriname', nativeName: 'Suriname' },
	{ countryCode: 'SJ', name: 'Svalbard and Jan Mayen', nativeName: 'Svalbard og Jan Mayen' },
	{ countryCode: 'SZ', name: 'Swaziland', nativeName: 'Swaziland' },
	{ countryCode: 'SE', name: 'Sweden', nativeName: 'Sverige' },
	{ countryCode: 'CH', name: 'Switzerland', nativeName: 'Schweiz' },
	{ countryCode: 'SY', name: 'Syria', nativeName: 'سوريا' },
	{ countryCode: 'ST', name: 'São Tomé and Príncipe', nativeName: 'São Tomé e Príncipe' },
	{ countryCode: 'TW', name: 'Taiwan', nativeName: '臺灣' },
	{ countryCode: 'TJ', name: 'Tajikistan', nativeName: 'Тоҷикистон' },
	{ countryCode: 'TZ', name: 'Tanzania', nativeName: 'Tanzania' },
	{ countryCode: 'TH', name: 'Thailand', nativeName: 'ประเทศไทย' },
	{ countryCode: 'BS', name: 'The Bahamas', nativeName: 'Bahamas' },
	{ countryCode: 'GM', name: 'The Gambia', nativeName: 'Gambia' },
	{ countryCode: 'TG', name: 'Togo', nativeName: 'Togo' },
	{ countryCode: 'TK', name: 'Tokelau', nativeName: 'Tokelau' },
	{ countryCode: 'TO', name: 'Tonga', nativeName: 'Tonga' },
	{ countryCode: 'TT', name: 'Trinidad and Tobago', nativeName: 'Trinidad and Tobago' },
	{ countryCode: 'TN', name: 'Tunisia', nativeName: 'تونس' },
	{ countryCode: 'TR', name: 'Turkey', nativeName: 'Türkiye' },
	{ countryCode: 'TM', name: 'Turkmenistan', nativeName: 'Türkmenistan' },
	{ countryCode: 'TV', name: 'Tuvalu', nativeName: 'Tuvalu' },
	{ countryCode: 'UG', name: 'Uganda', nativeName: 'Uganda' },
	{ countryCode: 'UA', name: 'Ukraine', nativeName: 'Україна' },
	{ countryCode: 'AE', name: 'United Arab Emirates', nativeName: 'دولة الإمارات العربية المتحدة' },
	{ countryCode: 'GB', name: 'United Kingdom', nativeName: 'United Kingdom' },
	{ countryCode: 'US', name: 'United States', nativeName: 'United States' },
	{ countryCode: 'UY', name: 'Uruguay', nativeName: 'Uruguay' },
	{ countryCode: 'UZ', name: 'Uzbekistan', nativeName: 'O‘zbekiston' },
	{ countryCode: 'VU', name: 'Vanuatu', nativeName: 'Vanuatu' },
	{ countryCode: 'VE', name: 'Venezuela', nativeName: 'Venezuela' },
	{ countryCode: 'VN', name: 'Vietnam', nativeName: 'Việt Nam' },
	{ countryCode: 'WF', name: 'Wallis and Futuna', nativeName: 'Wallis et Futuna' },
	{ countryCode: 'EH', name: 'Western Sahara', nativeName: 'الصحراء الغربية' },
	{ countryCode: 'YE', name: 'Yemen', nativeName: 'اليَمَن' },
	{ countryCode: 'ZM', name: 'Zambia', nativeName: 'Zambia' },
	{ countryCode: 'ZW', name: 'Zimbabwe', nativeName: 'Zimbabwe' },
] as const;
